export default __webpack_public_path__ + "images/0xe0654c8e6fd4d733349ac7e09f6f23da256bf475.png";